export type ErrorDataProps = {
  status: number;
  message: string;
};

export const UPLOAD_FAILS_TEXT =
  'Ups! Something went wrong 😔 please try again in a few minutes';
